/* Scents Creation v3: product page. Cart transport belongs to sc3-core. */
(() => {
  'use strict';
  if (window.SC3Product) return;
  const instances = new Map();
  const $ = (s, r) => r.querySelector(s);
  const $$ = (s, r) => Array.from(r.querySelectorAll(s));
  function enhanceNotes(node, t, root) {
    if (!node) return;
    const keyFor = text => /signature|ingredients|البصمة|النوتات الرئيسية|المكونات/i.test(text) ? 'signature' :
      /top|العليا|الافتتاحية/i.test(text) ? 'top' : /heart|middle|القلب|قلب العطر/i.test(text) ? 'heart' :
      /base|القاعدة|الأساسية/i.test(text) ? 'base' : '';
    const labels = $$('strong,b', node);
    let entries = [];
    if (labels.length && labels.every(label => keyFor(label.textContent))) {
      const preamble = document.createRange();
      preamble.selectNodeContents(node); preamble.setEndBefore(labels[0]);
      if (!preamble.toString().trim()) {
        entries = labels.map((label, i) => {
          const range = document.createRange();
          range.selectNodeContents(node); range.setStartAfter(label);
          if (labels[i + 1]) range.setEndBefore(labels[i + 1]);
          return { key: keyFor(label.textContent), title: label.textContent.replace(/\s*[（(].*$/, '').replace(/[:：]\s*$/, '').trim(), text: range.toString().replace(/^\s*[:：–—-]\s*/, '').trim() };
        });
      }
    }
    if (!entries.length) {
      const clone = node.cloneNode(true);
      $$('br', clone).forEach(br => br.replaceWith('\n'));
      $$('p,div,li', clone).forEach(block => block.append('\n'));
      const text = clone.textContent.trim();
      const pattern = /(?:^|\n|\s)(Top(?:\s+notes)?|Heart(?:\s+notes)?|Middle(?:\s+notes)?|Base(?:\s+notes)?|Scent signature|Signature|Ingredients|النوتات الرئيسية|البصمة العطرية|النوتات العليا|العليا|قلب العطر|القلب|نوتات القاعدة|القاعدة|المكونات)\s*[:：–—-]\s*/gi;
      const matches = Array.from(text.matchAll(pattern));
      if (matches.length && !text.slice(0, matches[0].index).trim()) {
        entries = matches.map((match, i) => ({
          key: keyFor(match[1]),
          text: text.slice(match.index + match[0].length, matches[i + 1]?.index ?? text.length).trim()
        }));
      }
    }
    if (entries.some(entry => !entry.text)) return;
    if (labels.length && !entries.length) return;
    const cleanNote = value => value.trim().replace(/[.:：]$/, '').trim()
      .replace(/^(?:(?:notes? accord|accord notes?|essence|ess|notes?|accord|خلاصة|نوتات|نوتة)(?:\s*[:：]\s*|\s+))+/i, '')
      .replace(/(?:\s+(?:notes? accord|accord notes?|essence|ess|notes?|accord|خلاصة|نوتات|نوتة))+$/i, '').trim();
    const main = $('[data-sc3-main-notes]', root);
    if (main && !$('li', main)) {
      const split = text => text.split(/[,،;؛\n|]+/).map(cleanNote).filter(Boolean);
      const signatures = entries.filter(entry => entry.key === 'signature').flatMap(entry => split(entry.text));
      // A prose layer is kept intact in the pyramid, never used as a note label.
      const notes = signatures.length ? signatures : !entries.length && !labels.length ? split(node.textContent) : [];
      const list = $('ul', main), seen = new Set();
      const categories = [["floral","rose|jasmine|iris|orange blossom|ورد|ياسمين|سوسن|زهر"],["citrus","bergamot|lemon|orange|grapefruit|mandarin|citrus|برغموت|ليمون|برتقال|جريب فروت|يوسفي|حمضيات"],["woody","cedar|sandal|vetiver|oud|wood|أرز|صندل|نجيل|عود|خشب|خشبية"],["spicy","pepper|saffron|ginger|cardamom|cinnamon|فلفل|زعفران|زنجبيل|هيل|قرفة"],["sweet","vanilla|tonka|caramel|honey|praline|فانيليا|تونكا|كراميل|عسل"],["amber","amber|ambroxan|labdanum|incense|عنبر|أمبروكسان|امبروكسان|لبان|بخور"],["musk","musk|مسك"],["fresh","mint|tea|green|marine|aquatic|نعناع|شاي|أخضر|بحري|مائي"],["fruity","apple|berry|peach|plum|pineapple|تفاح|توت|خوخ|برقوق|أناناس"],["leather","leather|tobacco|جلد|تبغ"]];
      notes.filter(note => note.length <= 45).forEach(note => {
        const key = note.toLocaleLowerCase();
        if (seen.has(key) || list.children.length >= 4) return;
        seen.add(key);
        const category = categories.find(([, words]) => words.split('|').some(word => key.includes(word)))?.[0] || 'drop';
        const template = $('[data-sc3-note-icon="' + category + '"]', root);
        if (!template) return;
        const item = document.createElement('li'), icon = document.createElement('span'), label = document.createElement('span');
        icon.className = 'sc3-note-icon'; icon.append(template.content.cloneNode(true));
        label.className = 'sc3-note-label'; label.textContent = note;
        item.append(icon, label); list.append(item);
      });
      main.hidden = !list.children.length;
    }
    if (!entries.length) return;
    const list = document.createElement('ol');
    list.className = 'sc3-product-pyramid';
    ['top', 'heart', 'base'].forEach(key => {
      entries.filter(entry => entry.key === key).forEach(entry => {
        const item = document.createElement('li'), body = document.createElement('div');
        const heading = document.createElement('p'), label = document.createElement('strong'), text = document.createElement('p');
        item.dataset.tier = key; label.textContent = t[key] + ':';
        heading.append(label);
        if (t[key + '_helper']) heading.append(' ' + t[key + '_helper']);
        text.className = 'sc3-note-list'; text.textContent = entry.text;
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', 'sc3-note-bottle'); svg.setAttribute('viewBox', '0 0 24 40');
        svg.setAttribute('width', '24'); svg.setAttribute('height', '32'); svg.setAttribute('aria-hidden', 'true');
        const outline = document.createElementNS(svg.namespaceURI, 'path'), liquid = document.createElementNS(svg.namespaceURI, 'path');
        outline.setAttribute('d', 'M9 2h6v5H9zM7 7h10v5H7zM4 12h16v26H4z');
        outline.setAttribute('fill', 'none'); outline.setAttribute('stroke', 'currentColor'); outline.setAttribute('stroke-width', '1.5');
        liquid.setAttribute('class', 'sc3-note-liquid'); liquid.setAttribute('d', 'M5 14h14v23H5z'); liquid.setAttribute('fill', 'currentColor');
        svg.append(outline, liquid); body.append(heading);
        if (entry.title && entry.title.toLowerCase() !== key && entry.title !== t[key]) {
          const title = document.createElement('h3'); title.className = 'sc3-note-title'; title.textContent = entry.title; body.append(title);
        }
        body.append(text); item.append(svg, body); list.append(item);
      });
    });
    // A signature-only fragment still carries information beyond the four main notes.
    if (list.children.length) node.replaceChildren(list);
  }
  function mount(root) {
    if (instances.has(root)) return;
    const config = JSON.parse(root.dataset.sc3ProductConfig), t = config.t;
    const variants = JSON.parse($('[data-sc3-variants]', root).textContent);
    const form = $('.sc3-product-form', root), idInput = $('[data-sc3-variant]', root);
    const options = $$('[data-sc3-option]', root), qty = $('[name="quantity"]', form);
    const main = $('[data-sc3-product-add]', root), sticky = $('[data-sc3-product-sticky]', root);
    const stickyAdd = $('[data-sc3-sticky-add]', root), status = $('[data-sc3-product-status]', root);
    const payment = $('[data-sc3-payment]', root), cleanup = [], abort = new AbortController();
    const notify = $('[data-sc3-notify]', root), similar = $('[data-sc3-similar]', root);
    const nearSlot = $('[data-sc3-recs-near]', root), endSlot = $('[data-sc3-recs-end]', root);
    const recs = $('[data-sc3-recommendations]', root), retry = $('[data-sc3-recommendations-retry]', recs);
    let current, busy = false, disposed = false, mainVisible = true;
    const on = (node, event, fn, opts) => {
      node.addEventListener(event, fn, opts);
      cleanup.push(() => node.removeEventListener(event, fn, opts));
    };
    const observe = (observer, node) => { observer.observe(node); cleanup.push(() => observer.disconnect()); };
    const money = cents => window.SC3.formatMoney(cents, config);
    function buttons() {
      [main, stickyAdd].forEach(button => {
        button.disabled = busy || (button === main ? !current?.available || !window.SC3?.cart?.add : current?.available && !window.SC3?.cart?.add);
        button.textContent = busy ? t.busy : current?.available ? t.add : button === main ? t.sold_out : t.notify;
        button.setAttribute('aria-busy', String(busy));
      });
      const unavailable = !current?.available;
      notify.hidden = !unavailable;
      similar.hidden = !unavailable;
      nearSlot.hidden = !unavailable;
      endSlot.hidden = unavailable;
      const slot = unavailable ? nearSlot : endSlot;
      if (recs.parentNode !== slot) slot.append(recs);
      if (unavailable) stickyAdd.setAttribute('aria-controls', notify.id);
      else stickyAdd.removeAttribute('aria-controls');
      if (payment) {
        payment.hidden = busy || unavailable;
        payment.inert = payment.hidden;
      }
    }
    function selectVariant(variant, updateURL = false) {
      current = variant;
      idInput.value = variant ? String(variant.id) : '';
      options.forEach((option, i) => { if (variant) option.value = variant.options[i]; });
      $$('[data-sc3-product-price]', root).forEach(node => { node.textContent = variant ? money(variant.price) : t.sold_out; });
      const was = $('[data-sc3-product-was]', root);
      was.hidden = !variant || !(variant.compare_at_price > variant.price);
      was.textContent = was.hidden ? '' : money(variant.compare_at_price);
      const saving = $('[data-sc3-product-saving]', root);
      if (saving) {
        saving.hidden = was.hidden;
        $('[data-sc3-saving-amount]', saving).textContent = was.hidden ? '' : money(Math.round((variant.compare_at_price - variant.price) / 100) * 100).replace(/[.,]00(?!\d)/, '');
      }
      buttons();
      if (updateURL) {
        const url = new URL(location.href);
        url.searchParams.delete('view');
        if (variant) url.searchParams.set('variant', variant.id);
        else url.searchParams.delete('variant');
        history.replaceState(history.state, '', url);
        // Shopify's payment component and existing variant observers see the current id.
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      const slide = variant?.featured_image && $('[data-sc3-slide="' + variant.featured_image.id + '"]', root);
      if (slide && updateURL) go(slides.indexOf(slide));
    }
    const gallery = $('[data-sc3-gallery]', root), slides = $$('[data-sc3-slide]', root);
    const galleryLinks = $$('[data-sc3-gallery-go]', root);
    function go(index) {
      if (!slides[index]) return;
      const offset = slides[index].getBoundingClientRect().left - gallery.getBoundingClientRect().left;
      gallery.scrollBy({ left: offset, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    galleryLinks.forEach(link => on(link, 'click', event => { event.preventDefault(); go(Number(link.dataset.sc3GalleryGo)); }));
    const currentSlide = () => slides.reduce((best, slide, i) =>
      Math.abs(slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left) <
      Math.abs(slides[best].getBoundingClientRect().left - gallery.getBoundingClientRect().left) ? i : best, 0);
    const prev = $('[data-sc3-gallery-prev]', root), next = $('[data-sc3-gallery-next]', root);
    if (prev) on(prev, 'click', () => go(Math.max(0, currentSlide() - 1)));
    if (next) on(next, 'click', () => go(Math.min(slides.length - 1, currentSlide() + 1)));
    let frame = 0;
    on(gallery, 'scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        const origin = gallery.getBoundingClientRect().left;
        const index = slides.reduce((best, slide, i) =>
          Math.abs(slide.getBoundingClientRect().left - origin) < Math.abs(slides[best].getBoundingClientRect().left - origin) ? i : best, 0);
        galleryLinks.forEach(link => {
          if (Number(link.dataset.sc3GalleryGo) === index) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        const counter = $('[data-sc3-gallery-count]', root);
        if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
      });
    }, { passive: true });
    cleanup.push(() => cancelAnimationFrame(frame));
    on(gallery, 'keydown', event => {
      if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      const index = currentSlide();
      const rtl = getComputedStyle(gallery).direction === 'rtl';
      go(Math.max(0, Math.min(slides.length - 1, index + ((event.key === 'ArrowLeft') === rtl ? 1 : -1))));
    });
    if (options.length) {
      $('[data-sc3-options]', root).hidden = false;
      $('[data-sc3-variant-fallback]', root).hidden = true;
      options.forEach(option => on(option, 'change', () => {
        const values = options.map(input => input.value);
        selectVariant(variants.find(variant => variant.options.every((value, i) => value === values[i])), true);
      }));
    }
    on(idInput, 'change', () => selectVariant(variants.find(variant => String(variant.id) === idInput.value)));
    const urlVariant = new URL(location.href).searchParams.get('variant');
    selectVariant(variants.find(variant => String(variant.id) === (urlVariant || idInput.value)));
    on(window, 'popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      selectVariant(id ? variants.find(variant => String(variant.id) === id) : variants.find(variant => variant.available) || variants[0]);
    });
    $$('[data-sc3-step]', root).forEach(button => on(button, 'click', () => {
      qty.value = Math.max(1, Math.floor(Number(qty.value) || 1) + Number(button.dataset.sc3Step));
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    // The Opus cart app binds its own capture click handler to add-to-cart buttons and adds the line itself
    // (cart/add.js?opus=true), which skips our confirmation toast, the header count and the Ego gift refresh.
    // Catch the click first (window capture runs before the button's own listeners) and submit through our handler.
    on(window, 'click', event => {
      const button = event.target.closest?.('button[type="submit"], input[type="submit"]');
      if (!button || button.form !== form) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!button.disabled) form.requestSubmit(button);
    }, true);
    on(form, 'submit', async event => {
      // Document-capture kit validation runs first. Stop legacy delegated form handlers.
      event.preventDefault(); event.stopImmediatePropagation();
      if (busy || !current?.available || !form.reportValidity()) return;
      if (!window.SC3?.cart?.add) { status.textContent = t.error; return; }
      const data = new FormData(form), properties = {};
      data.forEach((value, name) => {
        const match = name.match(/^properties\[(.+)\]$/);
        if (match && typeof value === 'string') properties[match[1]] = value;
      });
      if (config.kit && Array.from({ length: 6 }, (_, i) => properties['Tester #' + (i + 1)]).some(value => !value?.trim())) return;
      busy = true; status.textContent = ''; buttons();
      try { await window.SC3.cart.add({ id: current.id, quantity: Number(qty.value), properties }); }
      catch (_) { if (!disposed) status.textContent = t.error; }
      finally { if (!disposed) { busy = false; buttons(); } }
    }, true);
    const scrollTo = node => {
      if (!node || node.hidden) return;
      node.focus({ preventScroll: true });
      node.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    on(similar, 'click', event => { event.preventDefault(); scrollTo(recs); });
    on(stickyAdd, 'click', () => {
      if (!current?.available) { scrollTo(notify); return; }
      main.focus({ preventScroll: true });
      // A real click traverses the kit builder's capture listener before submission.
      main.click();
    });
    const mobile = matchMedia('(max-width: 989px)');
    function toastOffset() {
      const height = !sticky.hidden && mobile.matches ? sticky.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--sc3-toast-offset', height + 'px');
    }
    function stickyState() {
      sticky.hidden = !mobile.matches || mainVisible || document.documentElement.classList.contains('sc3-lock') ||
        !!document.querySelector('.sckb-sheet.is-open');
      toastOffset();
    }
    on(mobile, 'change', stickyState);
    on(window, 'resize', toastOffset, { passive: true });
    if ('ResizeObserver' in window) observe(new ResizeObserver(toastOffset), sticky);
    cleanup.push(() => document.documentElement.style.setProperty('--sc3-toast-offset', '0px'));
    stickyState();
    if ('IntersectionObserver' in window) {
      observe(new IntersectionObserver(entries => { mainVisible = entries[0].isIntersecting; stickyState(); }), main);
      const locks = new MutationObserver(stickyState);
      locks.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      cleanup.push(() => locks.disconnect());
      const sheet = document.querySelector('.sckb-sheet');
      if (sheet) locks.observe(sheet, { attributes: true, attributeFilter: ['class'] });
    }
    enhanceNotes($('[data-sc3-notes]', root), t, root);
    $('[data-sc3-dispatch]', root).textContent = t.next_day;
    let loading = false, loaded = false;
    async function recommendations() {
      if (loading || loaded) return;
      loading = true; retry.hidden = true; recs.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(recs.dataset.sc3RecommendationsUrl, { credentials: 'same-origin', signal: abort.signal });
        if (!response.ok) throw new Error();
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = $('[data-sc3-recommendation-grid]', doc);
        if (!grid) throw new Error();
        if (disposed) return;
        const target = $('[data-sc3-recommendation-grid]', recs);
        target.replaceChildren(...Array.from(grid.children).map(node => document.importNode(node, true)));
        recs.hidden = !target.children.length;
        loaded = true;
      } catch (_) { if (!disposed) retry.hidden = false; }
      finally { loading = false; recs.removeAttribute('aria-busy'); }
    }
    on(retry, 'click', recommendations);
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); recommendations(); }
      }, { rootMargin: '400px' });
      observe(observer, recs);
    } else recommendations();
    instances.set(root, () => { disposed = true; abort.abort(); cleanup.reverse().forEach(fn => fn()); instances.delete(root); });
  }
  function init(scope = document) {
    if (scope.matches?.('[data-sc3-product]')) mount(scope);
    $$('[data-sc3-product]', scope).forEach(mount);
  }
  window.SC3Product = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((dispose, root) => { if (event.target.contains(root)) dispose(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();